import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { IncomeCategoryListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { IncomeCategoryService } from './income-category.service';
import { SharedModule } from '../shared/shared.module';
import { IncomeCategoryCreateComponent } from './create/create.component';
import { IncomeCategoryFormComponent } from './form/form.component';
import { IncomeCategoryEditComponent } from './edit/edit.component';

const routes: Routes = [
  {
    path: 'income-categories',
    component: IncomeCategoryListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'income-categories/create',
    component: IncomeCategoryCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'income-categories/:id/edit',
    component: IncomeCategoryEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    IncomeCategoryListComponent,
    IncomeCategoryCreateComponent,
    IncomeCategoryFormComponent,
    IncomeCategoryEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, IncomeCategoryService],
})
export class IncomeCategoryRoutingModule {}
